var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{staticClass:"mr-2",attrs:{"size":_vm.size,"color":"grey lighten-5"}},[_c('div',{class:_vm.size!='66px'?'imagePreviewWrapperSmall':'imagePreviewWrapper',style:({'background-image': ("url(" + _vm.image + ")")})})])}
var staticRenderFns = []

export { render, staticRenderFns }